import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import _ from "lodash";
import account from "../assets/images/account-info.png";
import retail from "../assets/images/retail.png";
import Logo from "../assets/images/Logo-small.png";
import users from "../assets/images/users.png";
import bank from "../assets/images/bank.png";
import pinImage from "../assets/images/pin.png";
import letter from "../assets/images/letter.png";
import { ReactComponent as ArrowIcon } from "../assets/icons/arrow.svg";
import { requestGet, requestPatch, requestPost } from "../api/coreInstance";
import ModalLoading from "../components/ModalLoading";
import AccountDetailsFragment from "../fragment/register/AccountDetailsFragment";
import OutletDetailsFragment from "../fragment/register/OutletDetailsFragment";
import UserDetailsFragment from "../fragment/register/UserDetailsFragment";
import BankDetailsFragment from "../fragment/register/BankDetailsFragment";
import PolicyAgreementFragment from "../fragment/register/PolicyAgreementFragment";
import PinSetupFragment from "../fragment/register/PinSetupFragment";
import withAuth from "../components/withAuth";
import Button from "../components/Button/Button";
import HeaderStep from "../components/HeaderStep";
import { useAuth } from "../components/auth/authContext";
import { toastNotify } from "../utils/Utils";
import { useTranslation } from "react-i18next";
import KartiniCopyright from "../components/KartiniCopyright";

const Register = () => {
  const [fragment, setFragment] = useState("account-details");
  const [isScrolled, setIsScrolled] = useState(false);
  const [isCheckPolicy, setIsCheckPolicy] = useState(false);
  const [step, setStep] = useState(-1);
  const [fragmentHistory, setFragmentHistory] = useState(["account-details"]);
  const [showModalLoading, setShowModalLoading] = useState(false);
  const [pin, setPin] = useState("");
  const [inputPin, setInputPin] = useState({
    pin: "",
    pin_verify: "",
  });
  const { t } = useTranslation();
  // navigate
  const { state } = useLocation();
  const navigate = useNavigate();
  const { fetchAuthData } = useAuth();
  const { user, outlet, addOnUser, token } = state ?? {};
  const userOutlet = _.first(
    user?.userOutlet?.filter((outlet) => outlet.isActive === true),
  );

  async function SavePin() {
    setPin(inputPin.pin);
    setFragment("policy-agreement");

    await requestGet(`/dompet-kartini-pin?userOutlet=${userOutlet?.id}`, {
      headers: { Authorization: `Bearer ${token}` },
    }).then((res) => {
      if (!_.isEmpty(res.data.data)) {
        let dompetKartiniPin = res.data.data[0];
        requestPatch(
          `/dompet-kartini-pin/${dompetKartiniPin.id}`,
          {
            pinCode: inputPin.pin,
          },
          {
            headers: { Authorization: `Bearer ${token}` },
          },
        )
          .then((res) => {
            setStep(5);
          })
          .catch((error) => console.error(error));
      } else {
        requestPost(
          `/dompet-kartini-pin`,
          {
            pinCode: inputPin.pin,
            pinStatus: "active",
            userOutlet: userOutlet?.id,
          },
          {
            headers: { Authorization: `Bearer ${token}` },
          },
        )
          .then((res) => {
            setStep(5);
          })
          .catch((error) => console.error(error));
      }
    });
  }

  const validateButton = () => {
    if (step === 4) {
      if (
        _.isEmpty(inputPin.pin) ||
        inputPin.pin !== inputPin.pin_verify ||
        inputPin.pin_verify.length !== 6
      ) {
        return true;
      }
    } else if (step === 5) {
      if (!isCheckPolicy) {
        return true;
      }
    } else {
      return false;
    }
  };

  async function CompletedRegistration(params) {
    const dataAccount = addOnUser.outlet?.retailer;
    setShowModalLoading(true);
    try {
      // CHECK IF EXIST
      let policyResponse = await requestGet(
        `mitra-policy?retailer=${dataAccount.id}&userOutlet=${userOutlet?.id}`,
        {
          headers: { Authorization: `Bearer ${user.tokenUser}` },
        },
      );

      policyResponse = policyResponse.data.data[0] ?? null;

      // PATCH IF IS EXIST
      if (!_.isEmpty(policyResponse)) {
        await requestPatch(
          `mitra-policy/${policyResponse?.id}`,
          {
            policyStatus: "agree",
          },
          { headers: { Authorization: `Bearer ${user.tokenUser}` } },
        );
        // POST IF IS DOSNT EXIST
      } else {
        await requestPost(
          `mitra-policy`,
          {
            policyStatus: "agree",
            retailer: dataAccount.id,
            userOutlet: userOutlet?.id,
          },
          { headers: { Authorization: `Bearer ${user.tokenUser}` } },
        );
      }

      // UPDATE STATUS USER OUTLET
      await requestPatch(
        `user-outlet/${userOutlet?.id}`,
        {
          status: "LIVE",
        },
        { headers: { Authorization: `Bearer ${user.tokenUser}` } },
      );
      toastNotify(
        "Congratulations, you're officially registered! We're excited to have you on board. You can now log in and explore everything we have to offer.",
        "success",
      );
      setTimeout(() => {
        localStorage.setItem("dompet_user", JSON.stringify(user));
        localStorage.setItem(
          "dompet_detail_outlet",
          JSON.stringify({ ...outlet, retailer: dataAccount }),
        );
        localStorage.setItem("token_user", user.tokenUser);
        fetchAuthData();
        navigate("/", { replace: true });
      }, 5000);
    } catch (error) {
      console.error(error);
      toastNotify(error, "error");
    }
    setShowModalLoading(false);
  }

  const handleNextClick = () => {
    if (step === 4) {
      SavePin();
    } else if (step === 5) {
      CompletedRegistration();
    } else {
      setStep(step + 1);
    }
  };

  useEffect(() => {
    if (
      fragment !== "account-details" &&
      fragmentHistory[fragmentHistory.length - 1] !== fragment
    ) {
      setFragmentHistory([...fragmentHistory, fragment]);
    }
  }, [fragment]);

  return (
    <div className="relative h-screen">
      {/* Modal Loading */}
      <ModalLoading
        showModal={showModalLoading}
        setShowModal={setShowModalLoading}
      />
      {/* Pages Register */}
      {step === -1 ? (
        <div className="bg-greetings flex min-h-screen w-full flex-col justify-between pt-10">
          <div className="flex flex-col items-center gap-36">
            <img src={Logo} alt="" className="w-10" />
            <img src={users} alt="" />
            <p className="text-4xl">&#x1F44B;</p>
          </div>

          <div className="mx-auto max-w-5xl">
            <div className="flex flex-col gap-4 text-center">
              <p className="px-5 text-2xl font-medium leading-tight">
                {t("register.greetings")}
              </p>
              <p className="mx-auto max-w-xl px-4 text-xs text-transparent-black-60">
                {t("register.greetingInfo")}
              </p>
              <div className="px-4">
                <Button
                  label={t("register.next")}
                  variant="gradient"
                  withIcon={<ArrowIcon className="text-monochrome-0" />}
                  fullWidth
                  onClick={() => setStep(0)}
                  // disabled={validateButton()}
                />
              </div>
              <div className="mt-4">
                <KartiniCopyright />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <>
          <HeaderStep
            title={
              step === 0
                ? t("register.accountTitle")
                : step === 1
                  ? t("register.storeTitle")
                  : step === 2
                    ? t("register.userTitle")
                    : step === 3
                      ? t("register.bankTitle")
                      : step === 4
                        ? t("register.pinTitle")
                        : t("register.agreementTitle")
            }
            subtitle={
              step === 0
                ? t("register.accountSubtitle")
                : step === 1
                  ? t("register.storeSubtitle")
                  : step === 2
                    ? t("register.userSubtitle")
                    : step === 3
                      ? t("register.bankSubtitle")
                      : step === 4
                        ? t("register.pinSubtitle")
                        : t("register.agreementSubtitle")
            }
            setStep={setStep}
            step={step}
            icon={
              step === 0
                ? account
                : step === 1
                  ? retail
                  : step === 2
                    ? users
                    : step === 3
                      ? bank
                      : step === 4
                        ? pinImage
                        : letter
            }
            disableBack={step === 0}
          />
          <div className="mx-auto max-w-5xl">
            <div className="px-4 pb-12 pt-3">
              <div className="space-y-5">
                {step === 0 ? (
                  <>
                    <AccountDetailsFragment
                      dataUser={user}
                      dataAccount={addOnUser.outlet?.retailer}
                      dataOutlet={outlet}
                    />
                  </>
                ) : step === 1 ? (
                  <>
                    <OutletDetailsFragment
                      dataOutlet={outlet}
                      dataAccount={addOnUser.outlet?.retailer}
                      token={token}
                    />
                  </>
                ) : step === 2 ? (
                  <>
                    <UserDetailsFragment
                      dataUser={user}
                      dataOutlet={outlet}
                      dataAccount={addOnUser.outlet?.retailer}
                      token={token}
                    />
                  </>
                ) : step === 3 ? (
                  <>
                    <BankDetailsFragment
                      dataUser={user}
                      dataOutlet={outlet}
                      setFragment={setFragment}
                      addOnUser={addOnUser}
                      dataAccount={addOnUser.outlet?.retailer}
                      token={token}
                    />
                  </>
                ) : step === 4 ? (
                  <>
                    <PinSetupFragment
                      setInputPin={setInputPin}
                      inputPin={inputPin}
                    />
                  </>
                ) : step === 5 ? (
                  <div>
                    <PolicyAgreementFragment setIsScrolled={setIsScrolled} />
                  </div>
                ) : (
                  <></>
                )}
              </div>
            </div>
            <div className="fixed bottom-0 left-0 right-0 bg-white shadow-md">
              <div className="mx-auto flex w-full max-w-5xl flex-col gap-3 p-3">
                {step === 5 && (
                  <label className="flex items-center gap-2">
                    <input
                      type="checkbox"
                      className="form-checkbox h-5 w-5"
                      checked={isCheckPolicy}
                      onChange={(e) => setIsCheckPolicy(e.target.checked)}
                    />
                    <span className="ml-2">
                      {t("register.agreementStatement")}
                    </span>
                  </label>
                )}
                <div className="flex items-center justify-center gap-3 md:justify-end">
                  <div className="flex w-full gap-2 md:w-1/4">
                    <Button
                      label={t("register.back")}
                      variant="default"
                      fullWidth
                      disabled={step === 0}
                      onClick={() => setStep(step - 1)}
                    />
                    <Button
                      label={t("register.next")}
                      variant="gradient"
                      withIcon={<ArrowIcon className="text-monochrome-0" />}
                      fullWidth
                      onClick={handleNextClick}
                      disabled={validateButton()}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default withAuth(Register, { protectedRoute: false });
